import { IconButton, IconButtonProps, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiMessageSquare } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { urls } from "../../urls";
import { useSub } from "../subscription/useSub";
import { useAssistantPanel } from "./assistantPanelContext";

export const AssistantPanelTrigger = (props: Partial<IconButtonProps>) => {
  const { t } = useTranslation();
  const { hasAssistantAccess } = useSub();
  const { openPanel } = useAssistantPanel();
  const { pathname } = useLocation();

  if (!hasAssistantAccess || pathname === urls.v2.assistant) {
    return null;
  }

  return (
    <Tooltip label={t("Assistant")}>
      <IconButton
        aria-label={t("Assistant") ?? "Assistant"}
        icon={<FiMessageSquare />}
        variant="ghost"
        size="md"
        onClick={openPanel}
        {...props}
      />
    </Tooltip>
  );
};
